export default __webpack_public_path__ + "static/media/MarketRealCase2-en.0c2e3a6b.jpg";